import {
  Component,
  Host,
  h,
  State,
  Event,
  EventEmitter,
  Prop,
  Listen,
  Element,
} from '@stencil/core';
import { SessionRepository, SessionModel, SessionHelperService } from '@cesare';
import { LOCATIONS, QwLocation } from '../../index';
import {
  getSessionSettingsFromSessionStorage,
  removeFusionIdFromSessionStorage,
  sessionStorageGetItem,
  sessionStorageRemoveItem,
} from '../../core/storage/storage.service';
import {
  getLocationValueFromUrl,
  isInGroup,
  setSessionSettingsToSessionStorage,
} from '../../core/app/app';
import { isRunningLocally } from '../../core/utils';

@Component({
  tag: 'qw-location-list',
  styleUrl: 'qw-location-list.scss',
  shadow: false,
})
export class QwLocationList {
  @Element() el: HTMLElement;
  @Prop() qwLocationListLocations: any;
  @Prop() currentLang: string = 'en';
  @Prop() hasSubtitle: boolean = false;
  @Prop() isInGroup: boolean = false;
  @State() session: SessionModel;
  @State() qwLocationList: QwLocation[];
  @State() isSessionLoading: boolean = false;
  @Event() qwBasketWillBeReset: EventEmitter<void>;
  @Event() changeLocationLink: EventEmitter<string | void>;
  @Event() showServiceMessage: EventEmitter<any>;

  public componentWillLoad() {
    this.qwLocationListLocations = this.qwLocationListLocations
      ? this.qwLocationListLocations
      : JSON.stringify(LOCATIONS);

    SessionRepository.sessionIsLoading$.subscribe(
      (isLoading) => (this.isSessionLoading = isLoading),
    );
    this.qwLocationList = this.formatLocationListDataToQwLocationList();
    const currentLocation = getLocationValueFromUrl();
    if (!isInGroup() && !isRunningLocally()) {
      const locationValue = this.qwLocationList.find(
        (el) => el.value == currentLocation,
      ).hotelId;
      locationValue ? this.showServiceMessage.emit(locationValue) : '';
    }
  }

  private formatLocationListDataToQwLocationList() {
    let locationToDisplay = this.qwLocationListLocations.hostel;
    if (locationToDisplay == undefined) {
      locationToDisplay = JSON.parse(this.qwLocationListLocations).hostel;
    }
    if (!isInGroup()) {
      locationToDisplay = locationToDisplay.filter(
        (location) => location.value !== 'root',
      );
    }
    return locationToDisplay.map((h) => ({
      value: h.value,
      name: h.name,
      hotelId: h.hotel_id,
      engineId: h.engine_id,
      link: `/${h.value}/${this.currentLang}/rooms`,
      subtitle: h.subtitle,
    }));
  }

  private toggleLocations() {
    this.el.classList.toggle('qw-component--show');
  }

  public onClickLocation(newLocation: QwLocation | any) {
    this.toggleLocations();
    this.emitLocation(newLocation);
    let id =
      newLocation.hotel_id == undefined
        ? newLocation.hotelId
        : newLocation.hotel_id;
    this.showServiceMessage.emit(id);
    const sessionSettings = JSON.parse(
      sessionStorage.getItem('sessionSettings'),
    );
    const updatedSessionSettings = sessionSettings
      ? {
          ...sessionSettings,
          location: { ...sessionSettings.location, ...newLocation },
        }
      : { location: { ...newLocation } };

    sessionStorage.setItem(
      'sessionSettings',
      JSON.stringify(updatedSessionSettings),
    );
  }

  private emitLocation(location) {
    this.changeLocationLink.emit(location);
  }

  @Listen('changeLocation', { target: 'window' })
  changeLocation(location: CustomEvent<QwLocation['value']>) {
    const newLocationId = LOCATIONS.hostel.find(
      (l) => l.value == location.detail,
    )?.hotel_id;

    const sessionSetting = getSessionSettingsFromSessionStorage();
    setSessionSettingsToSessionStorage(sessionSetting, newLocationId);

    let sessionId =
      (this.session && this.session.sessionId) ||
      sessionStorageGetItem('fusionId');
    if (!sessionId) {
      return (window.location.pathname = `/${location.detail}/${this.currentLang}/`);
    } else {
      removeFusionIdFromSessionStorage();
      SessionHelperService.removeSessionIdFromCookie();
      sessionStorageRemoveItem('promoCode');

      return (window.location.pathname = `/${location.detail}/${this.currentLang}/`);
    }
  }

  render() {
    return (
      this.qwLocationList && (
        <Host
          class={`
        ${this.isSessionLoading ? 'qw-location-list--disabled' : ''}
      `}
        >
          <span
            class="qw-location-list__close"
            onClick={() => this.toggleLocations()}
          >
            {' '}
          </span>
          {this.qwLocationList.map((l: QwLocation) => {
            return (
              <div
                class="qw-location-list__item"
                onClick={() => this.onClickLocation(l)}
              >
                {l.name}
                {this.hasSubtitle ? (
                  <span class="qw-location-list__subtitle">{l.subtitle}</span>
                ) : (
                  ''
                )}
              </div>
            );
          })}
        </Host>
      )
    );
  }
}
